import { RelatedObjectType } from 'dashboard/apps/InquiryTemplateEditor/hooks/useIsEditableWithOptions';
import usePermission from 'lib/hooks/usePermission';
import { Permission } from 'lib/permissions';

/**
 * @name `useHasITEWritePermissionsForObjects`
 *
 * A hook that returns whether the current user has the required
 * write permissions to make template changes in ITE.
 */
export default (objectTypes: RelatedObjectType[] = []) => {
  const hasTemplateWritePermission = usePermission(Permission.InquiryTemplateWrite);
  const permissions = [hasTemplateWritePermission];

  const hasVerificationTemplateWritePermission = usePermission(
    Permission.VerificationTemplateWrite,
    { global: true },
  );

  if (objectTypes.includes('verification-template')) {
    permissions.push(hasVerificationTemplateWritePermission);
  }

  return permissions.every((permission) => permission === true);
};
